import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxMaskPipe } from 'ngx-mask';
import type { OrderDto } from '@api/models';
import { ShipmentPayerEnum, ShippingMethodEnum } from '@api/models';
import { PHONE_NUMBER_MASK } from '@/constants';
import { RouterLinkWithLang } from '@/directives/router-link-with-lang/router-link-with-lang.directive';

@Component({
  selector: 'cmt-order-details',
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss',
  imports: [TranslatePipe, RouterLink, RouterLinkWithLang, NgxMaskPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderDetailsComponent {
  readonly order = input.required<OrderDto>();
  readonly isShipmentPayerRecipient = input<boolean>();

  protected readonly PHONE_NUMBER_MASK = PHONE_NUMBER_MASK;
  protected readonly isShippingMethodDelivery = computed(() => {
    const type = this.order().shipment.recipient.address.type;
    return type === ShippingMethodEnum.WAREHOUSE || type === ShippingMethodEnum.DOORS;
  });
  protected readonly shipmentPayerRecipient = computed(() => {
    const payer = this.order().shipment.payerType;
    return this.isShipmentPayerRecipient()
      ?? (payer ? payer === ShipmentPayerEnum.RECIPIENT : undefined);
  });
}
